import { render } from "./tasks.vue?vue&type=template&id=a5c3f140&scoped=true"
import script from "./tasks.vue?vue&type=script&lang=js"
export * from "./tasks.vue?vue&type=script&lang=js"

import "./tasks.vue?vue&type=style&index=0&id=a5c3f140&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5c3f140"]])

export default __exports__